export default __webpack_public_path__ + "static/media/48.fdcda62d.svg";